module.exports = __webpack_public_path__ + "media/images/pic/brodno/gallery/2020/pygmalion/big/3-d378b8a5d95039547d6ec1fbccb86a58.webp";